import { render, staticRenderFns } from "./rounded-title.vue?vue&type=template&id=23eca232&scoped=true"
import script from "./rounded-title.vue?vue&type=script&lang=js"
export * from "./rounded-title.vue?vue&type=script&lang=js"
import style0 from "./rounded-title.vue?vue&type=style&index=0&id=23eca232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eca232",
  null
  
)

export default component.exports